"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12.513 3.5a1 1 0 0 0-.948 0l-6.22 3.349a.5.5 0 0 0 0 .88l6.457 3.477a.5.5 0 0 0 .474 0l6.456-3.477a.5.5 0 0 0 0-.88zm7.564 5.478a.5.5 0 0 0-.737-.44l-6.538 3.52a.5.5 0 0 0-.263.44v8.095a.5.5 0 0 0 .762.426l6.3-3.878a1 1 0 0 0 .476-.851zm-9.3 12.041a.5.5 0 0 0 .762-.426v-8.094a.5.5 0 0 0-.263-.44L4.737 8.538a.5.5 0 0 0-.737.44v7.312a1 1 0 0 0 .476.851z"
}), 'BoxFilled');
//# sourceMappingURL=index.js.map